import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export interface JoinMiniTournamentPayload {
  tournament_id: number;
}

export interface JoinMiniTournamentResponse {
  success: boolean;
  tournament_id?: number;
  message?: string;
  error?: string;
}

export default function useJoinMiniTournamentApi(
  handleOnSuccess?: (data: JoinMiniTournamentResponse) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<
  JoinMiniTournamentResponse,
  unknown,
  JoinMiniTournamentPayload
> {
  return useMutation<
    JoinMiniTournamentResponse,
    unknown,
    JoinMiniTournamentPayload
  >(
    async (payload: JoinMiniTournamentPayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/join_mini_tournament/',
        payload,
      );
      return response.data;
    },
    {
      onSuccess: (data: JoinMiniTournamentResponse) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to join mini tournament:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
